import { resetProjectTargetCosts } from '../State/projectTargetCosts'
import { resetProjectTargetAmounts } from '../State/projectTargetAmounts'

export default () => (dispatch) => {

  dispatch(resetProjectTargetCosts())
  dispatch(resetProjectTargetAmounts())

}
